import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { Repo } from '@repos/repo.service';

export interface AdminUser {
	email: string;
	name: string;
	phone: string;
}

@Injectable({
	providedIn: 'root',
})
export class AdminUsersService extends Repo<AdminUser, unknown> {
	GetCollectionPath(): string {
		return 'users_admin';
	}

	constructor(private firestore: AngularFirestore) {
		super(firestore);
	}
}
